module.exports = __webpack_public_path__ + "static/flags/PC-31899ee72fab8a6f3723622b5c0753c8.gif";